if (!customElements.get('tb-journal-story')) {
 customElements.define('tb-journal-story',class extends HTMLElement {
  connectedCallback() {
   if (this.dataset.ready) return;
   this.dataset.ready='true';
   const prose=this.querySelector('.tb-jr__prose');
   if (!prose) return;
   // Keep readers on this site when following external article resources.
   const siteHost=location.hostname.toLowerCase().replace(/^www\./,'');
   prose.querySelectorAll('a[href]').forEach(link=>{
    let url;
    try {url=new URL(link.getAttribute('href'),document.baseURI);} catch {return;}
    const host=url.hostname.toLowerCase().replace(/^www\./,'');
    if(!['http:','https:'].includes(url.protocol) || host===siteHost || host==='tylerbarks.com') return;
    link.target='_blank';
    link.relList.add('noopener');
    const label=link.getAttribute('aria-label') || link.textContent.trim() || link.querySelector('img')?.alt || 'External resource';
    if(!/opens in (?:a )?new tab/i.test(label)) link.setAttribute('aria-label',label+' (opens in a new tab)');
   });
   const toc=this.querySelector('.tb-jr__toc'), list=toc?.querySelector('ol');
   const headings=[...prose.querySelectorAll('h2,h3')].filter(h=>h.textContent.trim());
   if (list && headings.length>1) {
    headings.forEach((heading,index)=>{
     if (!heading.id) {
      let id=this.id+'-chapter-'+(index+1);
      while(document.getElementById(id)) id+='-next';
      heading.id=id;
     }
     const item=document.createElement('li'),link=document.createElement('a');
     link.href='#'+encodeURIComponent(heading.id);link.textContent=heading.textContent.trim();
     item.append(link);list.append(item);
    });
    toc.hidden=false;
   }
   const scope=this.closest('main')||document;
   const overview=[...scope.querySelectorAll('[data-story-overview]')].find(el=>el.dataset.articleId===this.dataset.articleId);
   if(overview) {
    const opening=overview.querySelector('[data-story-opening-copy]');
    const paragraph=[...prose.querySelectorAll(':scope > p')].find(el=>el.textContent.trim());
    if(opening && paragraph) {
     opening.replaceChildren(paragraph);
    }
    const target=overview.querySelector('[data-story-toc-target]');
    if(target && toc && list && headings.length>1) {
     target.append(toc);
     target.hidden=false;
    }
   }
   if(this.dataset.layout==='video') {
    const media=prose.querySelector('video,iframe[src*="youtube.com/embed/"],iframe[src*="youtube-nocookie.com/embed/"],iframe[src*="player.vimeo.com/video/"]');
    const stage=this.querySelector('.tb-jr__video-stage');
    if(media && stage) {
     if(media.tagName==='VIDEO') {media.autoplay=false;media.removeAttribute('autoplay');media.controls=true;}
     else {
      try {const url=new URL(media.src,location.href);url.searchParams.set('autoplay','0');media.src=url.href;} catch {}
      if(!media.title) media.title='Video for '+(this.querySelector('h1')?.textContent.trim()||'this story');
     }
     stage.append(media);stage.hidden=false;
     this.querySelectorAll('[data-video-fallback]').forEach(el=>el.hidden=true);
    }
   }
  }
 });
}

